import { create } from "zustand";
import { Service, Package, Addon } from "@/types";

interface PackageState {
  services: Service[];
  packages: Package[];
  addons: Addon[];
  loading: boolean;
  setServices: (services: Service[]) => void;
  addService: (service: Service) => void;
  updateService: (id: string, updates: Partial<Service>) => void;
  removeService: (id: string) => void;
  setPackages: (packages: Package[]) => void;
  setAddons: (addons: Addon[]) => void;
  setLoading: (loading: boolean) => void;
  getServiceById: (id: string) => Service | undefined;
  getPackageById: (id: string) => Package | undefined;
  getAddonById: (id: string) => Addon | undefined;
}

export const usePackageStore = create<PackageState>((set, get) => ({
  services: [],
  packages: [],
  addons: [],
  loading: false,
  setServices: (services) => set({ services }),
  addService: (service) =>
    set((state) => ({
      services: [...state.services, service].sort((a, b) => a.order - b.order),
    })),
  updateService: (id, updates) =>
    set((state) => ({
      services: state.services
        .map((s) => (s.id === id ? { ...s, ...updates } : s))
        .sort((a, b) => a.order - b.order),
    })),
  removeService: (id) => set((state) => ({ services: state.services.filter((s) => s.id !== id) })),
  setPackages: (packages) => set({ packages }),
  setAddons: (addons) => set({ addons }),
  setLoading: (loading) => set({ loading }),
  getServiceById: (id) => get().services.find((s) => s.id === id),
  getPackageById: (id) => get().packages.find((p) => p.id === id),
  getAddonById: (id) => get().addons.find((a) => a.id === id),
}));
